<script setup lang="ts">
    export interface AlgoliaFacetPopoverProps {
        id: 'age' | 'category' | 'colors' | 'height' | 'wheels' | 'sort';
        facetName: string;
        hideOnMobile?: boolean;
        sortItems?: { label: string; value: string }[];
        currentSort?: string;
    }

    const props = withDefaults(defineProps<AlgoliaFacetPopoverProps>(), { hideOnMobile: true });

    const identifier = `facet_${props.id}`;

    const computedLabel = computed(() => {
        if (props.id === 'sort' && props.sortItems && props.currentSort) {
            const found = props.sortItems.find((item) => item.value === props.currentSort);

            if (found) return `${props.facetName} ${found.label}`;
        }
        return props.facetName;
    });
</script>
<template>
    <div
        :class="['mol-algolia-facet-popover lg:inline-block', { 'max-lg:hidden': hideOnMobile }]"
        :style="{ '--anchor-name': `--facet-${identifier}` }">
        <atm-button
            :class="['facet-button capitalize', id]"
            :popovertarget="identifier"
            styling="outline">
            {{ computedLabel }}
            <template #icon>
                <woom-icon-chevron-down class="size-6" />
            </template>
        </atm-button>
        <div
            :class="['facet-popover overflow-hidden', id]"
            :id="identifier"
            popover>
            <!-- Must be 489px max height for showing 10 items -->
            <div class="max-h-122.25 overflow-auto">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<style scoped>
    @reference "#main.css";
    .facet-button {
        anchor-name: var(--anchor-name);
    }

    .facet-popover {
        @apply mt-px rounded-lg border border-woom-grey-taupe;
        top: anchor(bottom);
        left: anchor(left);
    }

    .facet-popover.sort {
        @apply left-auto md:origin-top-right;
        right: anchor(right);
        @variant max-md {
            width: anchor-size(width);
        }
    }
</style>
